import { render, staticRenderFns } from "./KeywordSearchForm.vue?vue&type=template&id=15f9243b&scoped=true&"
import script from "./KeywordSearchForm.vue?vue&type=script&lang=js&"
export * from "./KeywordSearchForm.vue?vue&type=script&lang=js&"
import style0 from "./KeywordSearchForm.vue?vue&type=style&index=0&id=15f9243b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f9243b",
  null
  
)

/* custom blocks */
import block0 from "./KeywordSearchForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports